import {
    createLoadingSpinner,
    LoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
} from '@vfde-brix/ws10/loading-spinner';
import { startAppListening } from '../../../app/listener';
import { selectIsLoading } from '../selectors';

/**
 * Mount loading spinner
 */
export const mountLoadingSpinner = (containerId: string): LoadingSpinner | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const loadingSpinner = createLoadingSpinner(container, {
        business: {},
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
    });

    listenForUpdates(loadingSpinner);

    return loadingSpinner;
};

const listenForUpdates = (loadingSpinner: LoadingSpinner) => {
    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectIsLoading(currentState) !== selectIsLoading(previousState)
        ,
        effect: (_action, listenerApi) => {
            const isLoading = selectIsLoading(listenerApi.getState());
            loadingSpinner?.toggle(isLoading);
        },
    });
};
